import React, {useEffect, useState} from 'react'
import Select from 'react-select'
import {
  HazardStatusClient,
  HazardStatusQueryParams,
} from '../../../infrastracture/api/HazardStatusClient'
import customStyles from './customStyles'

interface Props {
  name?: string
  defaultValue?: any
  placeholder?: string
  disabled?: boolean
  onChange?: (name: any, value: any, label: any) => void
  setDefault?: (name: any, value: any, label: any) => void
  isPublic?: boolean
}

const HazardStatusSelector: React.FC<Props> = (props: any) => {
  const {defaultValue, placeholder, disabled, name, setDefault, isPublic} = props
  const [options, setOptions] = useState([])
  const [value, setValue] = useState<any>({})

  const defaultId = 'hazardStatusId'

  useEffect(() => {
    populateData()
  }, [])

  useEffect(() => {
    if (value != defaultValue) setValue(defaultValue)
  }, [defaultValue])

  const populateData = async () => {
    var query = new HazardStatusQueryParams()
    if (isPublic) {
      //TODO: SUPPORT SEARCH FOR PERFORMANCE AGAINST LARGE COLLECTIONS
      var data = (
        await HazardStatusClient.PublicList(
          query.Paginate(0, 10000).Sort('name', 'asc').WithEnabled(true)
        )
      ).data

      if (data) {
        setOptions(
          data.data.map((item: any) => {
            return {
              value: item.id,
              label: item.name,
            }
          })
        )

        if (setDefault) {
          var defaultStatus = data.data.filter((x: any) => x.default)[0]

          if (defaultStatus) setDefault('hazardStatusId', defaultStatus.id, defaultStatus.name)
        }
      }
    } else {
      //TODO: SUPPORT SEARCH FOR PERFORMANCE AGAINST LARGE COLLECTIONS
      var data = (
        await HazardStatusClient.List(
          query.Paginate(0, 10000).Sort('name', 'asc').WithEnabled(true)
        )
      ).data

      if (data) {
        setOptions(
          data.data.map((item: any) => {
            return {
              value: item.id,
              label: item.name,
            }
          })
        )

        if (setDefault) {
          var defaultStatus = data.data.filter((x: any) => x.default)[0]

          if (defaultStatus) setDefault('hazardStatusId', defaultStatus.id, defaultStatus.name)
        }
      }
    }
  }

  const handleChange = (values: any) => {
    const {onChange} = props
    const {label, value} = values
    setValue(values)
    onChange(defaultId, value, label)
  }

  return (
    <Select
      onChange={handleChange}
      // onInputChange={(event: any) => {
      //   event.preventDefault()
      // }}
      value={value}
      options={options}
      placeholder={placeholder}
      isDisabled={disabled}
      id={name ? name : defaultId}
      name={name ? name : defaultId}
      menuPortalTarget={document.body}
      styles={customStyles}
      // menuPosition={'fixed'}
    />
  )
}

export default HazardStatusSelector
